const _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = createSvgIcon;

const _extends2 = _interopRequireDefault(require('@babel/runtime/helpers/extends'));

const _react = _interopRequireDefault(require('react'));

const _SvgIcon = _interopRequireDefault(require('@mui/material/SvgIcon'));

function createSvgIcon(path, displayName) {
  const Component = _react.default.memo(
    _react.default.forwardRef(function (props, ref) {
      return _react.default.createElement(
        _SvgIcon.default,
        (0, _extends2.default)(
          {
            ref: ref,
          },
          props
        ),
        path
      );
    })
  );

  if (process.env.NODE_ENV !== 'production') {
    Component.displayName = ''.concat(displayName, 'Icon');
  }

  Component.muiName = _SvgIcon.default.muiName;
  return Component;
}
